// 其他信息
import { i18n } from '@/common/utils/i18n'
import { get } from 'lodash-es'

export default (state) => {
  let other = get(state, 'currentShopBaseDetail.isIllegal', {})
  return {
    title: i18n.gettext('是否有违规记录'),
    content: [
      {
        title: i18n.gettext('是否有违规记录'),
        label: +other.sIllegal === 1 ? i18n.gettext('是') : i18n.gettext('否')
      }
    ]
  }
}
